import { AnyAction } from 'redux';
import { NOT_PRICED_SET_MODAL_OPEN } from '../constants';

interface NotPricedModel {
  modalOpen: boolean;
}

const DEFAULT_STATE: NotPricedModel = {
  modalOpen: false,
};

export const notPriced = (
  state = DEFAULT_STATE,
  action: AnyAction
): NotPricedModel => {
  switch (action.type) {
    case NOT_PRICED_SET_MODAL_OPEN:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
